<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :headers="payHeaders" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table
            :headers="payHeaders"
            :items="payOrders"
            :options.sync="pagination"
            :server-items-length="totalPayOrders"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.UserCode }}</td>
                <td class="text-end font-weight-bold">{{item.TotalAmountVND | currency}}</td>
                <td class="text-end">{{ item.Deposit | currency}}</td>
                <td class="text-end">{{ item.PayLeft | currency}}</td>
                <td class="text-end">{{ item.Wallet | currency}}</td>
                <td class="text-end font-weight-bold">{{ item.Remain | currency}}</td>
                <td class="text-end">{{ item.OrderNumber | currency}}</td>
                <td class="text-end">{{ item.TotalPackage | currency}}</td>
                <td class="text-center pay-button">
                  <v-btn text icon color="red lighten-2" @click="openPayDetail(item.ID)">
                    <v-icon>fa-check-double</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-dialog v-model="dialogPayDetail" max-width="700px">
            <v-card>
              <v-card-title>
                <span class="title">Thanh toán đơn hàng</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md pa-0>
                  <v-layout row wrap>
                    <v-flex lg12>
                      <div>Mã khách hàng: {{payOrderDetail.UserCode}}</div>
                    </v-flex>
                    <v-flex lg12>
                      <div>Tài khoản: {{payOrderDetail.CustomerName}}</div>
                    </v-flex>
                    <v-flex lg12>
                       <v-text-field v-model="phoneNumber" label="Điện thoại" class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg12>
                       <v-text-field v-model="payOrderDetail.Address" label="Địa chỉ" class="input-group--focused"></v-text-field>
                    </v-flex>
                     <v-flex lg12>
                       <v-text-field v-model="shippingMethod" label="Hình thức ship" class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg12 class="font-weight-bold">
                      <div>Số đơn thanh toán: {{selected.length | currency}}</div>
                    </v-flex>
                    <v-flex lg12>
                      <v-data-table
                        :headers="orderHeader"
                        :items="payOrderDetail.Orders"
                        :mobile-breakpoint="100"
                        :items-per-page="100"
                        :hide-default-footer="true"
                        item-key="TransactionID"
                        show-select
                        v-model="selected"
                      >
                        <template v-slot:item="{ item }">
                          <tr :active="isOrderGroupSelected(item)" @click="toggleOrderSelection(item)">
                            <td>
                              <v-checkbox primary hide-details :input-value="isOrderGroupSelected(item)" @click.stop="toggleOrderSelection(item)"></v-checkbox>
                            </td>
                            <td>{{ item.TransactionCode }}</td>
                            <td class="text-end">{{ item.Weight | currency('',2) }}</td>
                            <td>
                              <a target="blank" :href="(item.OrderType == 1 ? '/don-hang/' : '/ky-gui/') + item.ID">{{ item.OrderCode }}</a>
                            </td>
                            <td class="text-end font-weight-bold">{{ item.TotalAmountVND | currency}}</td>
                            <td class="text-end">{{ item.Deposit | currency}}</td>
                            <td class="text-end">{{ item.PayLeft | currency}}</td>
                          </tr>
                        </template>
                        <template v-slot:body.append>
                          <tr>
                            <td colspan="2" class="font-weight-bold">Tổng</td>
                            <td class="text-end font-weight-bold">{{totalWeight | currency('',2)}}</td>
                            <td></td>
                            <td class="text-end font-weight-bold">{{totalAmount | currency}}</td>
                            <td class="text-end font-weight-bold">{{totalDeposit | currency}}</td>
                            <td class="text-end font-weight-bold">{{totalPayLeft | currency}}</td>
                          </tr>
                          <tr>
                            <td colspan="6" class="font-weight-bold">Phí ship</td>
                            <td class="text-end font-weight-bold">
                              <h-currency-input
                                class="fee-cn-footer"
                                v-model="shipFee"
                                :decimal="0"
                              ></h-currency-input>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="6" class="font-weight-bold"><v-text-field label="Phí khác" v-model="feeOtherName"></v-text-field></td>
                            <td class="text-end font-weight-bold">
                              <h-currency-input
                                class="fee-cn-footer"
                                v-model="feeOther"
                                :decimal="0"
                              ></h-currency-input>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="6" class="font-weight-bold">Số dư ví</td>
                            <td
                              class="text-end font-weight-bold"
                            >{{payOrderDetail.Wallet | currency}}</td>
                          </tr>
                          <tr>
                            <td colspan="6" class="font-weight-bold">Cần trả thêm</td>
                            <td class="text-end font-weight-bold">{{totalRemain | currency}}</td>
                          </tr>
                          <tr>
                            <td colspan="6" class="font-weight-bold"><v-select label="Hình thức thanh toán" v-model="method" :items="rechargeMethods" item-text="name" item-value="value" :readonly="csRole"></v-select></td>
                            <td class="text-end font-weight-bold">
                              <h-currency-input
                                class="fee-cn-footer"
                                v-model="inputCash"
                                :decimal="0"
                              ></h-currency-input>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                    <v-flex lg12 v-if="totalRemain > 0 && (adminRole || customerServiceRole)">
                      <v-checkbox label="Cho phép thanh toán khi dư ví không đủ." v-model="payWithoutBalance" class="font-weight-bold text-err"></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-3 white--text" @click="dialogPayDetail = false">Đóng</v-btn>
                <v-btn
                  color="green darken-3 white--text"
                  @click="savePayOrder"
                  :disabled="selected.length == 0 || (totalRemain > 0 && !payWithoutBalance)"
                >Thanh toán</v-btn>
                <v-btn absolute top right class="mt-5" @click="printPayOrder">
                  <v-icon color="red darken-2" class="mr-2">fa-print</v-icon>In đơn
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="loading" fullscreen>
            <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
              <v-layout justify-center align-center>
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-layout>
            </v-container>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
    <div class="pt-5">
      <h3>Lịch sử thanh toán</h3>
    </div>
    <payment-history class="px-0"></payment-history>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";
import { currency } from "@/commons/currency";
import { sendErrorNotice, getCurrentTime } from "@/commons/utils";
import PaymentHistoryList from "@/views/PaymentHistory/PaymentHistoryList.vue";
export default {
  components: {
    "hpo-filter": Filtering,
    "payment-history": PaymentHistoryList
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      timeout: 2000,
      payMode: false,
      search: "",
      feeOtherName: "",
      feeOther: 0,
      inputCash: 0,
      shipFee: 0,
      method: configs.RECHARGE_TYPE.Cash,
      shippingMethod: "",
      payWithoutBalance: false,
      rechargeMethods: _.filter(configs.RECHARGE_METHODS, function(o) { return o.value >= 90; }),
      payHeaders: [
        {
          text: "Khách hàng",
          value: "UserCode",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Tổng tiền",
          value: "TotalAmountVND",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Đã trả",
          value: "Deposit",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tiền thiếu",
          value: "PayLeft",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tài khoản",
          value: "Wallet",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cần trả thêm",
          value: "Remain",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Số đơn hàng",
          value: "OrderNumber",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng số kiện",
          value: "TotalPackage",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          align: "center",
          filterable: false,
          sortable: false
        }
      ],
      orderHeader: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          right: false
        },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end"
        },
        {
          text: "Đơn hàng",
          value: "ID",
          right: false
        },
        {
          text: "Tổng tiền",
          value: "TotalAmountVND",
          align: "end"
        },
        {
          text: "Đã trả",
          value: "Deposit",
          align: "end"
        },
        {
          text: "Còn thiếu",
          value: "PayLeft",
          align: "end"
        }
      ],
      selected: [],
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "payorder_list",      
      filterConditions: [],
      quickFilterConditions: [],
      dialogPayDetail: false,
      phoneNumber: '',
      orderStatus: configs.ORDER_STATUS_ENUM
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.filter_data();
      },
      deep: true
    },
    payOrderDetail() {
      if (this.payOrderDetail && this.payOrderDetail.Orders) {
        this.selected = this.payOrderDetail.Orders.slice();
      }
      this.phoneNumber = this.payOrderDetail ? this.payOrderDetail.PhoneNumber : '';
    }
  },
  computed: {
    ...mapState("payOrder", {
      payOrders: "all",
      totalPayOrders: "total",
      payOrderDetail: "selectedItem",
      loading: "loading",
    }),
    pages() {
      if (this.options.rowsPerPage == null || this.options.totalItems == null)
        return 0;

      return Math.ceil(this.options.totalItems / this.options.rowsPerPage);
    },
    selectedUniq() {
      return _.uniqBy(
        _.map(this.selected, (item) => ({
          ID: item.ID,
          OrderType: item.OrderType,
          TotalAmountVND: item.TotalAmountVND,
          Deposit: item.Deposit,
          PayLeft: item.PayLeft,
          Weight: item.Weight
        })),
        (item) => `${item.OrderType}-${item.ID}`
      );
    },
    totalAmount() {
      return _.sumBy(this.selectedUniq, "TotalAmountVND");
    },
    totalWeight() {
      return _.sumBy(this.selected,"Weight");
    },
    totalDeposit() {
      return _.sumBy(this.selectedUniq, "Deposit");
    },
    totalPayLeft() {
      return _.sumBy(this.selectedUniq, "PayLeft");
    },
    totalRemain() {
      return this.payOrderDetail.Wallet >= this.totalPayLeft + this.shipFee + this.feeOther
        ? 0
        : this.totalPayLeft + this.shipFee + this.feeOther - this.payOrderDetail.Wallet;
    },
    customerServiceRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
  },
  methods: {
    getOrderGroupKey(item) {
      return `${item.OrderType}-${item.ID}`;
    },
    getOrderGroupItems(item) {
      return _.filter(_.get(this.payOrderDetail, "Orders", []), (order) => this.getOrderGroupKey(order) === this.getOrderGroupKey(item));
    },
    isOrderGroupSelected(item) {
      const orderGroupItems = this.getOrderGroupItems(item);
      if (_.isEmpty(orderGroupItems)) {
        return false;
      }

      const selectedTransactionIds = new Set(_.map(this.selected, "TransactionID"));
      return _.every(orderGroupItems, (order) => selectedTransactionIds.has(order.TransactionID));
    },
    toggleOrderSelection(item) {
      const orderGroupItems = this.getOrderGroupItems(item);
      if (_.isEmpty(orderGroupItems)) {
        return;
      }

      const shouldSelect = !this.isOrderGroupSelected(item);
      const groupTransactionIds = new Set(_.map(orderGroupItems, "TransactionID"));

      if (shouldSelect) {
        this.selected = _.uniqBy(this.selected.concat(orderGroupItems), "TransactionID");
        return;
      }

      this.selected = _.filter(this.selected, (selectedItem) => !groupTransactionIds.has(selectedItem.TransactionID));
    },
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("payOrder/getPayOrderList", param);
    },
    toggleAll() {
      if (this.selected.length === this.payOrderDetail.Orders.length)
        this.selected = [];
      else this.selected = this.payOrderDetail.Orders.slice();
    },
    openPayDetail(customerId) {
      this.$store.dispatch("payOrder/getPayOrderDetail", customerId);
      this.dialogPayDetail = true;
      this.payWithoutBalance = false;
      this.selected = [];
    },
    saveDeliverOrder(deliverable = 1) {
      let order_ids = _.map(_.filter(this.selected, {'OrderType': 1}), "ID");
      if(order_ids.length > 0) {
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: order_ids,
          Deliverable: deliverable
        });
      }
      let deposit_ids = _.map(_.filter(this.selected, {'OrderType': 2}), "ID");
      if(deposit_ids.length > 0) {
        this.$store.dispatch("deposit/updateMultiple", {
          OrderIDs: deposit_ids,
          Deliverable: deliverable
        });
      }
      this.$store.dispatch("orderTransaction/updateMultiple", {
        OrderIDs: order_ids,
        DepositIDs: deposit_ids,
        ShippingInfo: `${this.payOrderDetail.CustomerName} - ${this.phoneNumber} - ${this.payOrderDetail.Address}`,
        ShippingMethod: this.shippingMethod
      });
      this.dialogPayDetail = false;
      setTimeout(this.filter_data, 300);
    },
    savePayOrder() {
      if (this.selected.length == 0) {
        sendErrorNotice("Hãy chọn hóa đơn cần thanh toán");
        return;
      }
      // if (this.totalRemain > this.inputCash) {
      //   sendErrorNotice("Hãy nhập thêm tiền mặt");
      //   return;
      // }
      this.$store.dispatch("payOrder/updatePayOrder", {
        order_ids: _.map(_.filter(this.selectedUniq, {'OrderType': 1}), "ID"),
        deposit_ids: _.map(_.filter(this.selectedUniq, {'OrderType': 2}), "ID"),
        cash: this.inputCash,
        method: this.method,
        shipFee: this.shipFee,
        feeOther: this.feeOther,
        feeOtherName: this.feeOtherName,
        customer_id: this.payOrderDetail.CustomerID,
        shippingMethod: this.shippingMethod,
        Addresss: this.payOrderDetail.Address,
        PhoneNumber: this.phoneNumber
      });
      this.$store.dispatch("orderTransaction/updateMultiple", {
        OrderIDs: _.map(_.filter(this.selectedUniq, {'OrderType': 1}), "ID"),
        DepositIDs: _.map(_.filter(this.selectedUniq, {'OrderType': 2}), "ID"),
        ShippingInfo: `${this.payOrderDetail.CustomerName} - ${this.phoneNumber} - ${this.payOrderDetail.Address}`,
        ShippingMethod: this.shippingMethod
      });
      this.dialogPayDetail = false;
      setTimeout(this.filter_data, 300);
    },
    printPayOrder() {
      let frame_printing = (`<html><head><title>Hóa đơn thanh toán</title>
      <meta charset="UTF-8">
      <style>
      * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
      }

      body {
          font-family: 'Arial', 'Roboto', sans-serif;
          width: 210mm;
          padding: 15mm;
          background: #fff;
          color: #000;
      }

      .invoice-container {
          max-width: 100%;
      }

      .header {
          text-align: center;
          margin-bottom: 20px;
          border-bottom: 2px solid #000;
          padding-bottom: 15px;
      }

      .title {
          font-size: 28px;
          font-weight: bold;
          color: #000;
          margin-bottom: 5px;
          text-transform: uppercase;
          letter-spacing: 1px;
      }

      .print-date {
          font-size: 13px;
          color: #000;
          margin-top: 8px;
      }

      .customer-info {
          background: #fff;
          padding: 15px;
          margin: 20px 0;
          border: 2px solid #000;
      }

      .info-row {
          display: flex;
          padding: 6px 0;
          font-size: 14px;
      }

      .info-label {
          font-weight: bold;
          min-width: 120px;
          color: #000;
      }

      .info-value {
          color: #000;
      }

      .order-summary {
          background: #fff;
          padding: 10px 15px;
          margin: 15px 0;
          border: 2px solid #000;
          font-size: 14px;
          font-weight: bold;
          color: #000;
      }

      table {
          width: 100%;
          border-collapse: collapse;
          margin: 20px 0;
          border: 2px solid #000;
      }

      thead {
          background: #000;
          color: #fff;
      }

      th {
          padding: 12px 8px;
          text-align: left;
          font-size: 13px;
          font-weight: bold;
          border: 1px solid #000;
          text-transform: uppercase;
          letter-spacing: 0.5px;
      }

      th.text-right {
          text-align: right;
      }

      th.text-center {
          text-align: center;
      }

      tbody tr {
          border: 1px solid #000;
      }

      tbody tr:nth-child(even) {
          background-color: #fff;
      }

      tbody tr:hover {
          background-color: #fff;
      }

      td {
          padding: 10px 8px;
          font-size: 13px;
          border: 1px solid #000;
      }

      td.text-right {
          text-align: right;
          font-family: 'Courier New', monospace;
      }

      td.text-center {
          text-align: center;
      }

      .order-code {
          font-weight: bold;
          color: #000;
      }

      .transaction-code {
          color: #000;
          font-size: 12px;
      }

      tfoot tr {
          border: 1px solid #000;
      }

      tfoot td {
          font-weight: bold;
          padding: 10px 8px;
          background: #fff;
          border: 1px solid #000;
      }

      .total-row {
          background: #fff !important;
          font-size: 14px;
      }

      .summary-row td {
          padding: 8px;
          font-size: 13px;
      }

      .final-total {
          background: #000 !important;
          color: #fff !important;
          font-size: 15px;
      }

      .footer {
          margin-top: 30px;
          padding-top: 20px;
          border-top: 2px solid #000;
          text-align: center;
      }

      .note-text {
          font-size: 12px;
          color: #000;
          font-style: italic;
      }

      .domain {
          font-weight: bold;
          color: #000;
          margin-top: 10px;
          font-size: 14px;
      }

      .signature-section {
          display: flex;
          justify-content: space-between;
          margin-top: 40px;
          padding: 0 30px;
      }

      .signature-box {
          text-align: center;
          width: 200px;
      }

      .signature-title {
          font-weight: bold;
          font-size: 13px;
          margin-bottom: 60px;
          color: #000;
      }

      .signature-name {
          font-style: italic;
          font-size: 12px;
          color: #000;
      }

      @media print {
          @page {
              size: A4;
              margin: 10mm;
          }

          body {
              margin: 0;
              padding: 10mm;
          }

          .invoice-container {
              page-break-inside: avoid;
          }

          tbody tr {
              page-break-inside: avoid;
          }
      }
      </style></head><body>`);

      frame_printing += `<div class='invoice-container'>
            <div class='header'>
                <div class='title'>Hóa đơn thanh toán</div>
                <div class='print-date'>Ngày in: ${getCurrentTime().format(configs.SHORT_DATE_FORMAT)}</div>
            </div>
            
            <div class='customer-info'>
                <div class='info-row'>
                    <span class='info-label'>Mã khách hàng:</span>
                    <span class='info-value'>${this.payOrderDetail.UserCode || ''}</span>
                </div>
                <div class='info-row'>
                    <span class='info-label'>Tên khách hàng:</span>
                    <span class='info-value'>${this.payOrderDetail.CustomerName || ''}</span>
                </div>
                <div class='info-row'>
                    <span class='info-label'>Số điện thoại:</span>
                    <span class='info-value'>${this.phoneNumber || ''}</span>
                </div>
                <div class='info-row'>
                    <span class='info-label'>Địa chỉ:</span>
                    <span class='info-value'>${this.payOrderDetail.Address || ''}</span>
                </div>
            </div>
            
            <div class='order-summary'>
                📦 Tổng số đơn hàng: ${this.selected.length}
            </div>
            
            <table>
                <thead>
                    <tr>
                        <th style='width: 10%'>Mã ĐH</th>
                        <th style='width: 18%'>Mã vận đơn</th>
                        <th class='text-center' style='width: 10%'>Cân nặng</th>
                        <th class='text-center' style='width: 12%'>Kích thước</th>
                        <th class='text-right' style='width: 15%'>Tổng tiền</th>
                        <th class='text-right' style='width: 15%'>Đã trả</th>
                        <th class='text-right' style='width: 15%'>Còn thiếu</th>
                    </tr>
                </thead>
                <tbody>`;
      
      for (let i = 0; i < this.selected.length; i++) {
        const element = this.selected[i];
        const transactionCode = element.TransactionCode || '--';
        const weight = element.Weight ? `${currency(element.Weight, '', 2)} kg` : '--';
        const size = element.Size || element.Dimension || '--';
        
        frame_printing += `
                    <tr>
                        <td class='order-code'>${element.OrderCode}</td>
                        <td class='transaction-code'>${transactionCode}</td>
                        <td class='text-center'>${weight}</td>
                        <td class='text-center'>${size}</td>
                        <td class='text-right'>${currency(element.TotalAmountVND)}</td>
                        <td class='text-right'>${currency(element.Deposit)}</td>
                        <td class='text-right'>${currency(element.PayLeft)}</td>
                    </tr>`;
      }
      
      let phi_khac = this.feeOtherName != '' ? 
        `<tr class='summary-row'>
            <td colspan='6' style='font-weight: bold'>${this.feeOtherName}</td>
            <td class='text-right' style='font-weight: bold'>${currency(this.feeOther)}</td>
        </tr>` : '';
      
      frame_printing += `
                </tbody>
                <tfoot>
                    <tr class='total-row'>
                        <td colspan='2'><strong>TỔNG CỘNG</strong></td>
                        <td class='text-right'>${currency(this.totalWeight, '', 2)} kg</td>
                        <td class='text-right'></td>
                        <td class='text-right'>${currency(this.totalAmount)}</td>
                        <td class='text-right'>${currency(this.totalDeposit)}</td>
                        <td class='text-right'>${currency(this.totalPayLeft)}</td>
                    </tr>
                    <tr class='summary-row'>
                        <td colspan='6'>Số dư ví hiện tại</td>
                        <td class='text-right'>${currency(this.payOrderDetail.Wallet)}</td>
                    </tr>
                    <tr class='summary-row'>
                        <td colspan='6'>Phí vận chuyển</td>
                        <td class='text-right'>${currency(this.shipFee)}</td>
                    </tr>
                    ${phi_khac}
                    <tr class='final-total'>
                        <td colspan='6'><strong>TỔNG TIỀN CẦN THANH TOÁN</strong></td>
                        <td class='text-right'><strong>${currency(this.totalRemain)}</strong></td>
                    </tr>
                </tfoot>
            </table>
            
            <div class='signature-section'>
                <div class='signature-box'>
                    <div class='signature-title'>Người lập phiếu</div>
                    <div class='signature-name'>(Ký, ghi rõ họ tên)</div>
                </div>
                <div class='signature-box'>
                    <div class='signature-title'>Khách hàng</div>
                    <div class='signature-name'>(Ký, ghi rõ họ tên)</div>
                </div>
            </div>
            
            <div class='footer'>
                <div class='note-text'>Cảm ơn quý khách đã sử dụng dịch vụ của chúng tôi!</div>
                <div class='domain'>${configs.SYSTEM_CONFIG.domain}</div>
            </div>
        </div>
        </body></html>`;
      
      var doc = document.getElementById('print_frame').contentWindow.document;
      doc.open();
      doc.write(frame_printing);
      doc.close();
      setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    }
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>

<style>
.pay-button {
  width: 135px;
}

.fee-cn-footer .v-text-field .v-label--active {
  right: 0px !important;
  left: auto !important;
}

.fee-cn-footer .v-text-field__slot input {
  text-align: right !important;
  font-size: 0.9em !important;
}
</style>
